import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, OnChanges, SimpleChanges, Input, Output, SimpleChange } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Observable, concat, from, of, Subscription, Subject } from 'rxjs';
import { map, switchMap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';

import { round1, round2 } from 'src/app/shared/round';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocItems } from 'src/app/shared/document';

@Component({
  selector: 'app-list-doc-items',
  templateUrl: './list-doc-items.component.html',
  styleUrls: ['./list-doc-items.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListDocItemsComponent implements OnInit, OnDestroy, OnChanges {

  private globalSettinsData: GlobalSettingsData;
  private docItemQuery: Subscription;
  private diSumQuery: Subscription;
  private diSaveQuery: Subscription;
  private diGroupQuery: Subscription;

  loading: boolean = false;

  selectedDocType: number;

  sDI: DocItems;

  @Input() canSeeU4etka: boolean;
  @Input() diText1Column: boolean = false;
  @Input() diText2Column: boolean = false;
  @Input() diOrderColumn: boolean = false;
  @Input() showPrice: boolean = true;
  @Input() showQuantity: boolean = true;

  @Input() diText1ColumnName: string = 'Примечание';
  @Input() diText2ColumnName: string = 'Состав';
  @Input() diOrderColumnName: string = 'Индекс';
  @Input() diU4ETKAColumnName: string = 'Учетка';

  @Input() docItems: DocItems[];

  @ViewChild('docItemTable') docItemTable: Table;

  allowOld: boolean = false;

  public get noItems(): boolean { return ((this.docItems || []).length < 1); }

  public get selection(): boolean { return this.sDI ? true : false; }

  constructor(
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  calculateRowSummary(di: DocItems) {
    console.log('*** ListDocItemsComponent calculateRowSummary: ' + di.DOCITEMID);

    switch (di.DOCTYPE) {

      case 1:
      case 12:
        di.DOCITEMSUMU4 = di.DOCITEMQTY * di.U4ETKA;

      case 4:

      // TODO: pdp - Primary document Price does not match
      // pdp ?: boolean;
      // Primary document Price does not match

      case 2:
      case 3:
      case 5:
      case 10:

        di.DOCITEMSUM = di.DOCITEMQTY * di.DOCITEMPRICE;

        break;
    }
  }

  calculateDocItemsFields(data: DocItems[]) {
    console.log('*** ListDocItemsComponent calculateDocItemsFields')
    this.docItems = data;

    this.diSumQuery =
      from(this.docItems)
        .pipe(switchMap(di => of(di)))
        .subscribe(di => {

          di.cloneIndex = 0;
          di.PRODVAT = (di.PRODVAT ?? this.globalSettinsData.vatValue);

          switch (di.DOCTYPE) {

            case 1:
            case 12:
              di.DOCITEMPRICEWOVAT = round1(di.DOCITEMPRICE / ((100.0 + di.PRODVAT) / 100.0));
              di.DOCITEMPRICE = round2(di.DOCITEMPRICEWOVAT * ((100.0 + di.PRODVAT) / 100.0));

            case 2:
            case 3:
            case 4:
            case 5:
            case 10:
              break;
          }
        });
  }

  ngOnDestroy(): void {
    console.log('*** ListDocItemsComponent ngOnDestroy: ')

    if (this.docItemQuery) { this.docItemQuery.unsubscribe(); }

    if (this.diSaveQuery) { this.diSaveQuery.unsubscribe(); }

    if (this.diSumQuery) { this.diSumQuery.unsubscribe(); }

    if (this.diGroupQuery) { this.diGroupQuery.unsubscribe(); }

  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ListDocItemsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'inputDocument':
          if (change.currentValue) {
          }
          break;

        case 'docItems':
          if (change.currentValue) {
            this.calculateDocItemsFields(change.currentValue);     // <= Raw docItems[] from database
          }
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** ListDocItemsComponent ngOnInit: ')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
  }

}

